import React from 'react';
import { useSelector } from 'react-redux';

import LoginSignUpModal, { LOGIN_SIGN_UP_MODAL } from '~/components/LoginSignUpModal';
import MaryMagicSurveyModal from '~/components/MaryMagicSurvey/MaryMagicSurveyModal';
import DelaysModal, { DELAYS_MODAL } from '~/components/Waitlist/DelaysModal';
import { FullScreenPrompt, FULL_SCREEN_PUSH_PROMPT_MODAL } from '~/components/NativePush';
import { EMPTY_OBJECT } from '~/core/util/object';
import { MARY_MAGIC_SURVEY_MODAL } from '../../constants/modalIds';

import useLazyCloseModal from './hooks/useLazyCloseModal';
import useCloseLoginModal from './hooks/useCloseLoginModal';
import { isModalOpen } from './util/modal';
import ProductModal from '../Membership/ProductModal';

export const ModalController = () => {
  const login = useSelector((state: any) => state.login);
  const runtime = useSelector((state: any) => state.runtime);
  const hasSubmittedMaryMagicSurvey = useSelector(
    (state: any) => state.maryMagicSurvey.hasSubmittedMaryMagicSurvey
  );
  const closeModal = useLazyCloseModal();
  useCloseLoginModal(runtime, closeModal);

  return (
    <>
      <LoginSignUpModal
        login={login}
        onClose={closeModal(LOGIN_SIGN_UP_MODAL)}
        open={isModalOpen(runtime.modal, LOGIN_SIGN_UP_MODAL)}
        runtime={runtime}
      />
      {!hasSubmittedMaryMagicSurvey && (
        <MaryMagicSurveyModal
          onClose={closeModal(MARY_MAGIC_SURVEY_MODAL)}
          open={isModalOpen(EMPTY_OBJECT, MARY_MAGIC_SURVEY_MODAL)}
        />
      )}

      <DelaysModal
        onClose={closeModal(DELAYS_MODAL)}
        open={isModalOpen(runtime.modal, DELAYS_MODAL)}
      />

      <FullScreenPrompt
        onClose={closeModal(FULL_SCREEN_PUSH_PROMPT_MODAL)}
        open={isModalOpen(runtime.modal, FULL_SCREEN_PUSH_PROMPT_MODAL)}
      />

      <ProductModal />
    </>
  );
};
